import { type FC, type ReactNode } from "react";

import { css } from "@emotion/css";

import { SkeletonContainer } from "../../common/components";
import { useSelectedOrganization } from "../../organizations/hooks";

interface DetailsSkeletonContainerProps {
    loading?: boolean;
    children: ReactNode;
}

export const DetailsSkeletonContainer: FC<DetailsSkeletonContainerProps> = ({ children, loading: parentIsLoading }) => {
    const { loading, isNotSelected } = useSelectedOrganization();

    return (
        <SkeletonContainer loading={parentIsLoading || loading || isNotSelected} height={500} className={skeletonStyle}>
            {children}
        </SkeletonContainer>
    );
};

const skeletonStyle = css`
    margin-top: 20px;
`;
